import {Option} from 'types';

export const dataTypesToOptions = (dataTypes: [string, string][]): Option[] =>
    dataTypes.map(([value, label]) => ({label, value}));
